// Generated types for SysMLElement
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLElementReadAPI extends ScopedNodeReadAPI {
  /** Human-readable name for this element */
  name: string;
  /** Textual description of this element */
  description?: string | null;
  /** Human-readable breadcrumb path for autocomplete search */
  search_path?: string | null;
}

export interface SysMLElementWriteAPI extends ScopedNodeWriteAPI {
  /** Human-readable name for this element */
  name: string;
  /** Textual description of this element */
  description?: string | null;
  /** Human-readable breadcrumb path for autocomplete search */
  search_path?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLElementReadAPISchemaObject = ScopedNodeReadAPISchemaObject.extend({
  name: z.string(),
  description: z.string().nullable().optional(),
  search_path: z.string().nullable().optional(),
}).passthrough();
export const SysMLElementReadAPISchema: z.ZodType<SysMLElementReadAPI> = SysMLElementReadAPISchemaObject;

export const SysMLElementWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({
  name: z.string(),
  description: z.string().nullable().optional(),
  search_path: z.string().nullable().optional(),
}).passthrough();
export const SysMLElementWriteAPISchema: z.ZodType<SysMLElementWriteAPI> = SysMLElementWriteAPISchemaObject;
